// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Y6nK","productName":"Table_productName__3SLAE"};